import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import CookieConsent from 'react-cookie-consent';

import '../assets/sass/grayscale.scss';

class Layout extends Component {
	render() {
		const { children } = this.props;
		return (
			<StaticQuery
				query={graphql`
					query SiteTitleQuery {
						site {
							siteMetadata {
								title
							}
						}
					}
				`}
				render={data => (
					<>
						<Helmet
							title={data.site.siteMetadata.title}
							meta={[
								{ name: 'description', content: 'Kam Chauhan - Marketing Expert' },
								{ name: 'keywords', content: 'Kam, Chauhan, Marketing Expert, UK' },
							]}
						>
							<html lang="en" />
							<script>{`
    (function(w,d,e,u,f,l,n){w[f]=w[f]||function(){(w[f].q=w[f].q||[])
    .push(arguments);},l=d.createElement(e),l.async=1,l.src=u,
    n=d.getElementsByTagName(e)[0],n.parentNode.insertBefore(l,n);})
    (window,document,'script','https://assets.mailerlite.com/js/universal.js','ml');
    ml('account', '564009');
`}</script>
						</Helmet>
						<div className={'page-top'}>{children}</div>
						{/* <CookieConsent
							location="bottom"
							buttonText="OK"
							declineButtonText="Decline"
							cookieName="kamchauhan"
						>
							We use cookies on our webite.
						</CookieConsent> */}
					</>
				)}
			/>
		);
	}
}

Layout.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Layout;
